import { createAction, createSlice } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { getDateTime } from '@sda/utils/date';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { HyperwalletAccountLog } from '@sda/interfaces/user/hyperwallet';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const startFetchHyperwalletAccountLogs = createAction<string>(`${Reducers.HYPERWALLET_LOGS}/startFetchHyperwalletAccountLogs`);

export const hyperwalletLogAdapter = createEntityAdapter<HyperwalletAccountLog & FetchDataType>({
  sortComparer: (a, b) => getDateTime(b.createdAt).toMillis() - getDateTime(a.createdAt).toMillis(),
});

const hyperwalletLogsSlice = createSlice({
  initialState: hyperwalletLogAdapter.getInitialState(),
  name: Reducers.HYPERWALLET_LOGS,
  reducers: {
    ...extractSharedActions(hyperwalletLogAdapter),
    setHyperwalletLogs: hyperwalletLogAdapter.setAll,
  },
});

export const { setHyperwalletLogs } = hyperwalletLogsSlice.actions;

export default hyperwalletLogsSlice.reducer;
